import { render, staticRenderFns } from "./HeaderInstructions.vue?vue&type=template&id=799a2060&scoped=true&"
var script = {}
import style0 from "./HeaderInstructions.vue?vue&type=style&index=0&id=799a2060&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799a2060",
  null
  
)

export default component.exports